import { useCallback, useEffect, useState } from 'react'

import clsx from 'clsx'

import { ScrollSnapSlider } from 'shared/ui/scroll-snap-slider'

import { ImageOptimized } from '../image-optimized'

import { CustomDots } from './components'
import s from './styles.module.scss'

type Props = {
  images?: { id: string; image: string; image_fullpath: string }[]
  errorImage?: string
  isRounded?: boolean
  dotsVariant?: 'default' | 'bar' | 'custom'
  showCounter?: boolean
  emptyStateImg?: string
  size?:
    | 'medium'
    | 'large'
    | 'small'
    | 'aspect'
    | 'square'
    | 'collectionsHorizontal'
    | 'collectionsGrid'
}

export const Carousel = ({
  images,
  errorImage,
  isRounded,
  dotsVariant = 'default',
  showCounter = false,
  // emptyStateImg,
  size = 'medium',
}: Props) => {
  const [currentSlide, setCurrentSlide] = useState(0)
  const totalSlides = images?.length || 0
  const slideImageWrapperClassName = clsx(
    s.slideImageWrapper,
    isRounded && s.rounded,
    s[size],
  )

  const handleDotClick = useCallback((slideIndex: number) => {
    setCurrentSlide(slideIndex)
  }, [])

  useEffect(() => {
    if (totalSlides <= 0) {
      if (currentSlide !== 0) {
        setCurrentSlide(0)
      }
      return
    }

    if (currentSlide > totalSlides - 1) {
      setCurrentSlide(totalSlides - 1)
    }
  }, [currentSlide, totalSlides])

  const isCustomDots = dotsVariant === 'custom'
  const shouldShowNativeDots = !isCustomDots && totalSlides > 1

  return (
    <div className={clsx(s.container, 'slider-container')}>
      {/* {!Boolean(images?.length) && emptyStateImg && (
        <ImageLazy
          src={errorImage}
          errorImage={errorImage}
          className={clsx(s.slideImage, isRounded && s.rounded, s[size])}
        />
      )} */}

      <ScrollSnapSlider
        activeIndex={currentSlide}
        onChange={setCurrentSlide}
        showArrows={false}
        strictSwipeStep
        slideWidth="100%"
        gap={0}
      >
        {images?.map((item, index) => (
          <ImageOptimized
            src={item.image_fullpath}
            alt="image"
            className={s.slideImage}
            wrapperClassName={slideImageWrapperClassName}
            key={item.id || item.image_fullpath || index}
            errorImage={errorImage}
            priority={index === 0}
          />
        ))}
      </ScrollSnapSlider>

      {shouldShowNativeDots && (
        <div
          className={clsx(s.dots, {
            [s.dotsBar]: dotsVariant === 'bar',
            [s.dotsDefault]: dotsVariant === 'default',
          })}
        >
          {Array.from({ length: totalSlides }, (_, index) => (
            <button
              key={index}
              type="button"
              onClick={() => handleDotClick(index)}
              className={clsx(s.dotItem, {
                [s.dotActive]: index === currentSlide,
              })}
              aria-label={`Перейти к слайду ${index + 1}`}
            />
          ))}
        </div>
      )}

      {isCustomDots && totalSlides > 1 && (
        <CustomDots
          size={size}
          dots={Array.from({ length: totalSlides }, (_, index) => (
            <button
              key={index}
              type="button"
              onClick={() => handleDotClick(index)}
              className={s.customDotButton}
            />
          ))}
          currentSlide={currentSlide}
          totalSlides={totalSlides}
        />
      )}

      {showCounter && totalSlides > 1 && (
        <div className={s.counter}>
          <span
            key={currentSlide}
            className={s.fade}
          >
            {currentSlide + 1}
          </span>
          /{totalSlides}
        </div>
      )}
    </div>
  )
}
